import React from 'react'

import preflight from './preflight'
import LangRouter from './routes/base/LangRouter'
import { initFirebase } from './components/shared/init-firebase'
import { MapProvider } from './components/shared/map-provider'

initFirebase()
preflight()

/**
 * Application root.
 *
 * Hosts the language router which mounts the actual BrowserRouter
 * scoped to the resolved locale. Wrapped by MapProvider so every
 * Google Maps consumer shares one APIProvider / script load.
 */
const Root = () => (
    <MapProvider>
        <LangRouter />
    </MapProvider>
)

export default Root
